import React, { ReactNode } from 'react';
import { Box, makeStyles } from 'housecall-ui';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

const useStyles = makeStyles((theme: HCPTheme) => ({
  wrapper: {
    overflow: 'auto',
    margin: `0 -${theme.spacing(3)}px`,
    padding: `0 ${theme.spacing(3)}px`,
  },
}));

type Props = { children: ReactNode };

export const ScrollableContent = ({ children }: Props) => {
  const { wrapper } = useStyles();

  return (
    <Box my={2} className={wrapper}>
      {children}
    </Box>
  );
};
